import { configureStore } from "@reduxjs/toolkit";

/*********** reducers imports ************/
import attachmentReducer from "../app/slices/attachmentSlice";
import authorReducer from "../app/slices/authorSlice";
import authReducer from "../app/slices/authSlice";
import bookReducer from "../app/slices/bookSlice";
import commonReducer from "../app/slices/commonSlice";
import languageReducer from "../app/slices/languageSlice";
import uploadReducer from "../app/slices/uploadSlice";
import userReducer from "../app/slices/userSlice";
import newsReducer from "../app/slices/newsSlice";
/*********** reducers imports ************/

export const store = configureStore({
  reducer: {
    auth: authReducer,
    users: userReducer,
    common: commonReducer,
    uploads: uploadReducer,
    attachments: attachmentReducer,
    books: bookReducer,
    authors: authorReducer,
    languages: languageReducer,
    news: newsReducer,
  },
});
